<template>
  <div class="customer-list">
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      class="scroll"
      @init="mescrollInit"
    >
      <div id="content">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item
            v-for="(item, index) in list"
            :name="index"
            :key="index"
            :title="item.prizeName"
          >
            <div class="content">
              <div class="list">
                <span class="list-left">奖品类型</span>
                <span class="list-right">{{ item.prizeType }}</span>
              </div>
              <div class="list">
                <span class="list-left">中奖时间</span>
                <span class="list-right">{{ item.createdTime }}</span>
              </div>
              <div class="list">
                <span class="list-left">数量</span>
                <span class="list-right">{{ item.prizeCount }}</span>
              </div>
              <div class="list">
                <span class="list-left">领取方式</span>
                <span class="list-right">{{ item.receiveMethod }}</span>
              </div>
              <div class="list"> 
                <span class="list-left">获奖方式</span>
                <span class="list-right">{{ item.rewardMechanism }}</span>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import noDataImg from "@/assets/images/img-default@2x.png";
export default {
  components: {
    MescrollVue,
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    }
  },
  data() {
    return {
      mescroll: null,
      mescrollDown: {
        callback: this.init
      },
      mescrollUp: {
        callback: this.getList,
        page: {
          num: 1,
          size: 10
        },
        htmlNodata: '<p class="upwarp-nodata">-- 没有更多数据了 --</p>',
        noMoreSize: 1,
        auto: true,
        empty: {
          // 列表第一页无任何数据时,显示的空提示布局; 需配置warpId才生效;
          warpId: 'content', // 父布局的id;
          icon: noDataImg, // 图标,支持网络图
          tip: '暂无数据', // 提示
        },
      },
      activeName: "1",
      list: [],
    };
  },
  methods: {
    init() {
      this.list = []
      // 下拉刷新的回调; 默认重置上拉加载列表为第一页
      this.mescroll.resetUpScroll()
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll
    },
    getList(page, mescroll) {
      const params = this.$route.query
      this.$api.countMoney.getCountMoneyActivityWinAwards({
        filterData: {...params},
        pageNum: page.num,
        pageSize: page.size,
      })
        .then(({data}) => {
          if (data.list) {
            this.list.push(...data.list);
            this.pageNum = data.pageNum + 1;
            mescroll.endSuccess(this.list.length, data.hasNextPage)
          }
        })
    },
  },
  filters: {
    receiveMethodStr(val) {
      const map = { 1: '线下核销', 2: '邮寄快递'}
      return map[val]
    },
    rewardMechanismStr(val) {
      const map = {1: '全国排名', 2: '办事处排名', 3: '阶梯奖励', 4: '随机奖励', 5: '鼓励奖励'}
      return map[val]
    }
  }
};
</script>
<style lang="stylus" scoped>
.customer-list {
  height: 100%;
  .title {
    display: flex;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
  }
  .content {
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 0;
      color: #999999;
      font-size: 14px;
      .list-right {
        position relative
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: 230px;
        flex-wrap: wrap;
        color: #333333;
      }
    }
  }
}
</style>
